/**
 * Autogenerated file don't modify
 */
(function () {
var tsBuild = (function (exports) {
    'use strict';

    MoyaComponents.register('ext.sticky-head', function (el) {
        var headSearch = new StickyHead(el);
        headSearch.run();
    });
    var StickyHead = /** @class */ (function () {
        function StickyHead(el) {
            this.shrinkOn = Number(el.dataset.shrinkOn);
        }
        StickyHead.prototype.run = function () {
            var distanceY = window.scrollY || document.documentElement.scrollTop;
            this.checkSticky(distanceY);
            this.listen();
        };
        StickyHead.prototype.checkSticky = function (distanceY) {
            if (distanceY > this.shrinkOn) {
                document.body.classList.add('stickyHead');
            }
            else {
                document.body.classList.remove('stickyHead');
            }
        };
        StickyHead.prototype.listen = function () {
            var _this = this;
            window.addEventListener('scroll', function () {
                var distanceY = window.scrollY || document.documentElement.scrollTop;
                _this.checkSticky(distanceY);
            });
        };
        return StickyHead;
    }());

    exports.StickyHead = StickyHead;

    return exports;

}({}));
typeof tsBuild === 'function' && tsBuild();})();
